import React from "react";
import "./HomePage.css";
import Bluearrow from "../assests/blueArrow.png";

function Judges({ judges, isJudgE, setJudgesPopup, setJudgeDetails }) {
  const handleClickJudge = (obj) => {
    setJudgeDetails(obj);
    setJudgesPopup(true);
  };
  return (
    <div className={`z-10  pt-[30px] mb-[32px] relative w-[100%] `}>
      <div className="flex items-center justify-between">
        <p className="text-large-medium">Judges</p>
        {/* <p className="cursor-pointer text-[#0F6ABE] inline-block">
          Details <img className=" inline-block" src={Bluearrow} alt="" />
        </p> */}
      </div>
      <div className="mt-[12px] grid grid-cols-3 gap-x-[5px] gap-y-[12px]">
        {judges?.map((obj, i) => {
          return (
            <div
              className="cursor-pointer flex flex-col items-center w-auto"
              onClick={() => handleClickJudge(obj)}
            >
              <img
                className="rounded-full w-[80px] h-[80px] object-cover judgesBg"
                src={obj?.logo}
                alt=""
              />
              <p className="judgesName">{obj?.name}</p>
              <p className="judjesDes">{obj?.position}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Judges;
